"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaApi = exports.MediaApiFactory = exports.MediaApiFp = exports.MediaApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * MediaApi - axios parameter creator
 * @export
 */
const MediaApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Deleting the cache by the key, not this is asynchronous operation and the cache will be deleted in the background.
         * @param {MediaCacheKeys} cacheKey Cache key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCacheKey: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ cacheKey }, options = {}) {
            // verify required parameter 'cacheKey' is not null or undefined
            (0, common_1.assertParamExists)('deleteCacheKey', 'cacheKey', cacheKey);
            const localVarPath = `/v1/media/cache/{cache_key}`.replace(`{${'cache_key'}}`, encodeURIComponent(String(cacheKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/cache/{cache_key}`,
                sdkMethod: 'deleteCacheKey',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft delete recipient\'s programs and all associated data, such as guides and pack classes
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('deletePrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deletePrograms', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/media`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/media`,
                sdkMethod: 'deletePrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Expunge recipient\'s programs and all associated data, such as guides and pack classes
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungePrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('expungePrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('expungePrograms', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/media/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/media/expunge`,
                sdkMethod: 'expungePrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch program config and user progress for recipient programs
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllRecipientPrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, xDevicePlatform, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getAllRecipientPrograms', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getAllRecipientPrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getAllRecipientPrograms', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/programs`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/programs`,
                sdkMethod: 'getAllRecipientPrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch user progress for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [clinicalProgramsOnly] If true, only return progress for clinical programs
         * @param {Array<string>} [packClasses] If provided, only return progress for the specified pack classes. If not provided, return progress for all pack classes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecipientProgress: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, clinicalProgramsOnly, packClasses, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getAllRecipientProgress', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getAllRecipientProgress', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/progress`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clinicalProgramsOnly !== undefined) {
                localVarQueryParameter['clinicalProgramsOnly'] =
                    clinicalProgramsOnly;
            }
            if (packClasses) {
                localVarQueryParameter['packClasses'] = packClasses;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/progress`,
                sdkMethod: 'getAllRecipientProgress',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch **Clinical** Packs and user progress for recipient programs configuration. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. This endpoint is working only with clinical programs. This endpoint will do **batch** calls to Content-Service to fetch pack, programs, guides for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalPacksByClass: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, rHGApp, recipientId, _class, xDevicePlatform, acceptLanguage, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getClinicalPacksByClass', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getClinicalPacksByClass', 'rHGApp', rHGApp);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getClinicalPacksByClass', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('getClinicalPacksByClass', '_class', _class);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs_clinical`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (_class) {
                localVarQueryParameter['class'] = _class;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs_clinical`,
                sdkMethod: 'getClinicalPacksByClass',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get recently played clinical guides, favorite clinical guides, favorite clinical programs
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalProgramGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getClinicalProgramGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getClinicalProgramGuide', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}`,
                sdkMethod: 'getClinicalProgramGuide',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given a pack class and Recipient ID, get a list of completed programs
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleted: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, _class, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getCompleted', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('getCompleted', '_class', _class);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getCompleted', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}/complete`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}/complete`,
                sdkMethod: 'getCompleted',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the content policy cookies for the user. Note: This requires the protected_media : r permission (DTC Users will not have this)
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCookies: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getCookies', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getCookies', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/cookies`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/cookies`,
                sdkMethod: 'getCookies',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch information related to dailies for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailiesData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, acceptLanguage, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getDailiesData', 'recipientId', recipientId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getDailiesData', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/media/recipients/{recipient_id}/dailies`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/dailies`,
                sdkMethod: 'getDailiesData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Pack configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackByClass: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, _class, rHGApp, circleAuthorizationToken, xDevicePlatform, acceptLanguage, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getPackByClass', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('getPackByClass', '_class', _class);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getPackByClass', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getPackByClass', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}`,
                sdkMethod: 'getPackByClass',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPacksByClass: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, rHGApp, recipientId, _class, xDevicePlatform, acceptLanguage, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getPacksByClass', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getPacksByClass', 'rHGApp', rHGApp);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getPacksByClass', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('getPacksByClass', '_class', _class);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (_class) {
                localVarQueryParameter['class'] = _class;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs`,
                sdkMethod: 'getPacksByClass',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch program config and user progress for program by program id
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgram: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, _class, programId, rHGApp, acceptLanguage, xDevicePlatform, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getProgram', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getProgram', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('getProgram', '_class', _class);
            // verify required parameter 'programId' is not null or undefined
            (0, common_1.assertParamExists)('getProgram', 'programId', programId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getProgram', 'rHGApp', rHGApp);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)))
                .replace(`{${'program_id'}}`, encodeURIComponent(String(programId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}`,
                sdkMethod: 'getProgram',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get guide config and recipient data for the guide
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, rHGApp, recipientId, _class, programId, guideId, acceptLanguage, xDevicePlatform, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientGuide', 'rHGApp', rHGApp);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientGuide', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientGuide', '_class', _class);
            // verify required parameter 'programId' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientGuide', 'programId', programId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientGuide', 'guideId', guideId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}/guides/{guide_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)))
                .replace(`{${'program_id'}}`, encodeURIComponent(String(programId)))
                .replace(`{${'guide_id'}}`, encodeURIComponent(String(guideId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}/guides/{guide_id}`,
                sdkMethod: 'getRecipientGuide',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch program configs for recipient and given pack classes
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {MediaPackProgramsRequest} [mediaPackProgramsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientPrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, xDevicePlatform, mediaPackProgramsRequest, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientPrograms', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientPrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getRecipientPrograms', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/programs`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (xDevicePlatform !== undefined && xDevicePlatform !== null) {
                localVarHeaderParameter['X-Device-Platform'] =
                    String(xDevicePlatform);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/programs`,
                sdkMethod: 'getRecipientPrograms',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaPackProgramsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary This endpoint returns the programs and guides matching the given search query.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} query Search query string
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [category] Category to filter by. Categories are dynamic, defined by /search/config call.
         * @param {string} [duration] Duration to filter by
         * @param {string} [narrator] Narrator to filter by
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, query, acceptLanguage, category, duration, narrator, page, pageSize, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getSearch', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getSearch', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getSearch', 'rHGApp', rHGApp);
            // verify required parameter 'query' is not null or undefined
            (0, common_1.assertParamExists)('getSearch', 'query', query);
            const localVarPath = `/v1/media/recipients/{recipient_id}/search`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }
            if (narrator !== undefined) {
                localVarQueryParameter['narrator'] = narrator;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/search`,
                sdkMethod: 'getSearch',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary This endpoint returns the search configuration for filtering search results (eg, categories to filter by).
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, acceptLanguage, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getSearchConfig', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getSearchConfig', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getSearchConfig', 'rHGApp', rHGApp);
            const localVarPath = `/v1/media/recipients/{recipient_id}/search/config`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/search/config`,
                sdkMethod: 'getSearchConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary This endpoint returns a list of recommended search terms based on the partial search term sent as the query.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} query Partial string to return recommended autocompleted search terms for.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {number} [limit] Maximum number of search term recommendations to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchRecommend: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, query, acceptLanguage, limit, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getSearchRecommend', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getSearchRecommend', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getSearchRecommend', 'rHGApp', rHGApp);
            // verify required parameter 'query' is not null or undefined
            (0, common_1.assertParamExists)('getSearchRecommend', 'query', query);
            const localVarPath = `/v1/media/recipients/{recipient_id}/search/recommend`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/search/recommend`,
                sdkMethod: 'getSearchRecommend',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary This endpoint returns a list of the top trending search terms.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchTrending: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rHGApp, acceptLanguage, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getSearchTrending', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getSearchTrending', 'recipientId', recipientId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getSearchTrending', 'rHGApp', rHGApp);
            const localVarPath = `/v1/media/recipients/{recipient_id}/search/trending`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/search/trending`,
                sdkMethod: 'getSearchTrending',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch information related to sleep stories for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepStoriesData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, acceptLanguage, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getSleepStoriesData', 'recipientId', recipientId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getSleepStoriesData', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/media/recipients/{recipient_id}/sleep-stories`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/sleep-stories`,
                sdkMethod: 'getSleepStoriesData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:       * reset progress duration for all guides in the pack class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRecipientPackClassPrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, _class, mediaUpdatePackClassPrograms, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('patchRecipientPackClassPrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('patchRecipientPackClassPrograms', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('patchRecipientPackClassPrograms', '_class', _class);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}/programs`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}/programs`,
                sdkMethod: 'patchRecipientPackClassPrograms',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdatePackClassPrograms, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, rHGApp, recipientId, _class, programId, guideId, acceptLanguage, mediaUpdateGuide, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('updateGuide', 'rHGApp', rHGApp);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateGuide', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('updateGuide', '_class', _class);
            // verify required parameter 'programId' is not null or undefined
            (0, common_1.assertParamExists)('updateGuide', 'programId', programId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('updateGuide', 'guideId', guideId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}/guides/{guide_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)))
                .replace(`{${'program_id'}}`, encodeURIComponent(String(programId)))
                .replace(`{${'guide_id'}}`, encodeURIComponent(String(guideId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}/guides/{guide_id}`,
                sdkMethod: 'updateGuide',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdateGuide, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s program data. This endpoint can be used to:       * favorite program   * store program reminder rrule   * join a program.     * **Note:** if the recipient has already left a program, they cannot rejoin   * leave a program     * **Note:**: a user must have joined a program in order to leave the program
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateProgram} [mediaUpdateProgram]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecipientProgram: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, _class, programId, acceptLanguage, mediaUpdateProgram, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateRecipientProgram', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateRecipientProgram', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('updateRecipientProgram', '_class', _class);
            // verify required parameter 'programId' is not null or undefined
            (0, common_1.assertParamExists)('updateRecipientProgram', 'programId', programId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'class'}}`, encodeURIComponent(String(_class)))
                .replace(`{${'program_id'}}`, encodeURIComponent(String(programId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}`,
                sdkMethod: 'updateRecipientProgram',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdateProgram, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {NotificationRecipientCopyRequest} [notificationRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, notificationRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient', 'recipientId', recipientId);
            const localVarPath = `/v1/notifications/recipients/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/notifications/recipients/{recipient_id}/copy`,
                sdkMethod: 'v1CopyDataToNewRecipient',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient_1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, mediaRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient_1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient_1', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/copy`,
                sdkMethod: 'v1CopyDataToNewRecipient_1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MediaGuideRecommendations: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1MediaGuideRecommendations', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1MediaGuideRecommendations', 'recipientId', recipientId);
            const localVarPath = `/v1/media/recipients/{recipient_id}/recommendations/guides`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/media/recipients/{recipient_id}/recommendations/guides`,
                sdkMethod: 'v1MediaGuideRecommendations',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MediaApiAxiosParamCreator = MediaApiAxiosParamCreator;
/**
 * MediaApi - functional programming interface
 * @export
 */
const MediaApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MediaApiAxiosParamCreator)(configuration);
    return {
        /**
         * Deleting the cache by the key, not this is asynchronous operation and the cache will be deleted in the background.
         * @param {MediaCacheKeys} cacheKey Cache key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCacheKey(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCacheKey(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Soft delete recipient\'s programs and all associated data, such as guides and pack classes
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Expunge recipient\'s programs and all associated data, such as guides and pack classes
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungePrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expungePrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch program config and user progress for recipient programs
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllRecipientPrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllRecipientPrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch user progress for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [clinicalProgramsOnly] If true, only return progress for clinical programs
         * @param {Array<string>} [packClasses] If provided, only return progress for the specified pack classes. If not provided, return progress for all pack classes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecipientProgress(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllRecipientProgress(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch **Clinical** Packs and user progress for recipient programs configuration. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. This endpoint is working only with clinical programs. This endpoint will do **batch** calls to Content-Service to fetch pack, programs, guides for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalPacksByClass(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClinicalPacksByClass(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get recently played clinical guides, favorite clinical guides, favorite clinical programs
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalProgramGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClinicalProgramGuide(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Given a pack class and Recipient ID, get a list of completed programs
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleted(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompleted(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the content policy cookies for the user. Note: This requires the protected_media : r permission (DTC Users will not have this)
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCookies(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCookies(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch information related to dailies for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailiesData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDailiesData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch Pack configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackByClass(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPackByClass(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPacksByClass(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPacksByClass(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch program config and user progress for program by program id
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgram(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProgram(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get guide config and recipient data for the guide
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecipientGuide(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch program configs for recipient and given pack classes
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {MediaPackProgramsRequest} [mediaPackProgramsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientPrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecipientPrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary This endpoint returns the programs and guides matching the given search query.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} query Search query string
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [category] Category to filter by. Categories are dynamic, defined by /search/config call.
         * @param {string} [duration] Duration to filter by
         * @param {string} [narrator] Narrator to filter by
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearch(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary This endpoint returns the search configuration for filtering search results (eg, categories to filter by).
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearchConfig(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary This endpoint returns a list of recommended search terms based on the partial search term sent as the query.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} query Partial string to return recommended autocompleted search terms for.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {number} [limit] Maximum number of search term recommendations to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchRecommend(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearchRecommend(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary This endpoint returns a list of the top trending search terms.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchTrending(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearchTrending(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch information related to sleep stories for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepStoriesData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSleepStoriesData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:       * reset progress duration for all guides in the pack class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRecipientPackClassPrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchRecipientPackClassPrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGuide(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s program data. This endpoint can be used to:       * favorite program   * store program reminder rrule   * join a program.     * **Note:** if the recipient has already left a program, they cannot rejoin   * leave a program     * **Note:**: a user must have joined a program in order to leave the program
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateProgram} [mediaUpdateProgram]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecipientProgram(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRecipientProgram(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {NotificationRecipientCopyRequest} [notificationRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CopyDataToNewRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient_1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CopyDataToNewRecipient_1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MediaGuideRecommendations(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MediaGuideRecommendations(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.MediaApiFp = MediaApiFp;
/**
 * MediaApi - factory interface
 * @export
 */
const MediaApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MediaApiFp)(configuration);
    return {
        /**
         * Deleting the cache by the key, not this is asynchronous operation and the cache will be deleted in the background.
         * @param {MediaCacheKeys} cacheKey Cache key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCacheKey(params, options) {
            return localVarFp
                .deleteCacheKey(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft delete recipient\'s programs and all associated data, such as guides and pack classes
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrograms(params, options) {
            return localVarFp
                .deletePrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Expunge recipient\'s programs and all associated data, such as guides and pack classes
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungePrograms(params, options) {
            return localVarFp
                .expungePrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch program config and user progress for recipient programs
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllRecipientPrograms(params, options) {
            return localVarFp
                .getAllRecipientPrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch user progress for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [clinicalProgramsOnly] If true, only return progress for clinical programs
         * @param {Array<string>} [packClasses] If provided, only return progress for the specified pack classes. If not provided, return progress for all pack classes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecipientProgress(params, options) {
            return localVarFp
                .getAllRecipientProgress(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch **Clinical** Packs and user progress for recipient programs configuration. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. This endpoint is working only with clinical programs. This endpoint will do **batch** calls to Content-Service to fetch pack, programs, guides for the recipient.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalPacksByClass(params, options) {
            return localVarFp
                .getClinicalPacksByClass(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get recently played clinical guides, favorite clinical guides, favorite clinical programs
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalProgramGuide(params, options) {
            return localVarFp
                .getClinicalProgramGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Given a pack class and Recipient ID, get a list of completed programs
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleted(params, options) {
            return localVarFp
                .getCompleted(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get the content policy cookies for the user. Note: This requires the protected_media : r permission (DTC Users will not have this)
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCookies(params, options) {
            return localVarFp
                .getCookies(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch information related to dailies for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailiesData(params, options) {
            return localVarFp
                .getDailiesData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Pack configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackByClass(params, options) {
            return localVarFp
                .getPackByClass(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPacksByClass(params, options) {
            return localVarFp
                .getPacksByClass(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch program config and user progress for program by program id
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgram(params, options) {
            return localVarFp
                .getProgram(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get guide config and recipient data for the guide
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientGuide(params, options) {
            return localVarFp
                .getRecipientGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch program configs for recipient and given pack classes
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
         * @param {MediaPackProgramsRequest} [mediaPackProgramsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipientPrograms(params, options) {
            return localVarFp
                .getRecipientPrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary This endpoint returns the programs and guides matching the given search query.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} query Search query string
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [category] Category to filter by. Categories are dynamic, defined by /search/config call.
         * @param {string} [duration] Duration to filter by
         * @param {string} [narrator] Narrator to filter by
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch(params, options) {
            return localVarFp
                .getSearch(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary This endpoint returns the search configuration for filtering search results (eg, categories to filter by).
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchConfig(params, options) {
            return localVarFp
                .getSearchConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary This endpoint returns a list of recommended search terms based on the partial search term sent as the query.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} query Partial string to return recommended autocompleted search terms for.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {number} [limit] Maximum number of search term recommendations to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchRecommend(params, options) {
            return localVarFp
                .getSearchRecommend(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary This endpoint returns a list of the top trending search terms.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchTrending(params, options) {
            return localVarFp
                .getSearchTrending(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch information related to sleep stories for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSleepStoriesData(params, options) {
            return localVarFp
                .getSleepStoriesData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:       * reset progress duration for all guides in the pack class
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRecipientPackClassPrograms(params, options) {
            return localVarFp
                .patchRecipientPackClassPrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuide(params, options) {
            return localVarFp
                .updateGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s program data. This endpoint can be used to:       * favorite program   * store program reminder rrule   * join a program.     * **Note:** if the recipient has already left a program, they cannot rejoin   * leave a program     * **Note:**: a user must have joined a program in order to leave the program
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} _class Pack Class
         * @param {string} programId Program ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateProgram} [mediaUpdateProgram]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecipientProgram(params, options) {
            return localVarFp
                .updateRecipientProgram(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {NotificationRecipientCopyRequest} [notificationRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient(params, options) {
            return localVarFp
                .v1CopyDataToNewRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient_1(params, options) {
            return localVarFp
                .v1CopyDataToNewRecipient_1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MediaGuideRecommendations(params, options) {
            return localVarFp
                .v1MediaGuideRecommendations(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.MediaApiFactory = MediaApiFactory;
/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
class MediaApi extends base_1.BaseAPI {
    /**
     * URL `/v1/media/cache/{cache_key}`
     * Deleting the cache by the key, not this is asynchronous operation and the cache will be deleted in the background.
     * @param {MediaCacheKeys} cacheKey Cache key name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    deleteCacheKey(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .deleteCacheKey(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/media`
     * Soft delete recipient\'s programs and all associated data, such as guides and pack classes
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    deletePrograms(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .deletePrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/media/expunge`
     * Expunge recipient\'s programs and all associated data, such as guides and pack classes
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    expungePrograms(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .expungePrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/programs`
     * Fetch program config and user progress for recipient programs
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getAllRecipientPrograms(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getAllRecipientPrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/progress`
     * Fetch user progress for recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {boolean} [clinicalProgramsOnly] If true, only return progress for clinical programs
     * @param {Array<string>} [packClasses] If provided, only return progress for the specified pack classes. If not provided, return progress for all pack classes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getAllRecipientProgress(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getAllRecipientProgress(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs_clinical`
     * Fetch **Clinical** Packs and user progress for recipient programs configuration. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. This endpoint is working only with clinical programs. This endpoint will do **batch** calls to Content-Service to fetch pack, programs, guides for the recipient.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getClinicalPacksByClass(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getClinicalPacksByClass(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}`
     * Get recently played clinical guides, favorite clinical guides, favorite clinical programs
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getClinicalProgramGuide(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getClinicalProgramGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}/complete`
     * Given a pack class and Recipient ID, get a list of completed programs
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getCompleted(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getCompleted(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/cookies`
     * Get the content policy cookies for the user. Note: This requires the protected_media : r permission (DTC Users will not have this)
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getCookies(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getCookies(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/dailies`
     * Fetch information related to dailies for the recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getDailiesData(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getDailiesData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}`
     * Fetch Pack configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getPackByClass(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getPackByClass(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs`
     * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getPacksByClass(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getPacksByClass(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}`
     * Fetch program config and user progress for program by program id
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {string} programId Program ID
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getProgram(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getProgram(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}/guides/{guide_id}`
     * Get guide config and recipient data for the guide
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {string} programId Program ID
     * @param {string} guideId Guide ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getRecipientGuide(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getRecipientGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/programs`
     * Fetch program configs for recipient and given pack classes
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {MediaDevicePlatform} [xDevicePlatform] X-Device-Platform header, used to determine the platform of the device. -This header is deprecated and will be removed in the future. - Use RHG-App header instead. The RHG-App header should be used to provide the platform information. - The RHG-App header should be in the format platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;os&#x3D;xyz;device-model&#x3D;abc
     * @param {MediaPackProgramsRequest} [mediaPackProgramsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getRecipientPrograms(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getRecipientPrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/search`
     *
     * @summary This endpoint returns the programs and guides matching the given search query.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} query Search query string
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [category] Category to filter by. Categories are dynamic, defined by /search/config call.
     * @param {string} [duration] Duration to filter by
     * @param {string} [narrator] Narrator to filter by
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getSearch(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getSearch(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/search/config`
     *
     * @summary This endpoint returns the search configuration for filtering search results (eg, categories to filter by).
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getSearchConfig(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getSearchConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/search/recommend`
     *
     * @summary This endpoint returns a list of recommended search terms based on the partial search term sent as the query.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} query Partial string to return recommended autocompleted search terms for.
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {number} [limit] Maximum number of search term recommendations to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getSearchRecommend(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getSearchRecommend(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/search/trending`
     *
     * @summary This endpoint returns a list of the top trending search terms.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getSearchTrending(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getSearchTrending(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/sleep-stories`
     * Fetch information related to sleep stories for the recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    getSleepStoriesData(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .getSleepStoriesData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}/programs`
     * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s programs in the packClass. This endpoint can be used to:       * reset progress duration for all guides in the pack class
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {MediaUpdatePackClassPrograms} [mediaUpdatePackClassPrograms]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    patchRecipientPackClassPrograms(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .patchRecipientPackClassPrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}/guides/{guide_id}`
     * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {string} programId Program ID
     * @param {string} guideId Guide ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaUpdateGuide} [mediaUpdateGuide]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    updateGuide(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .updateGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/packs/{class}/programs/{program_id}`
     * At least one field must be provided in the patch request body. All fields are optional, but at least one must be provided update recipient\'s program data. This endpoint can be used to:       * favorite program   * store program reminder rrule   * join a program.     * **Note:** if the recipient has already left a program, they cannot rejoin   * leave a program     * **Note:**: a user must have joined a program in order to leave the program
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} _class Pack Class
     * @param {string} programId Program ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaUpdateProgram} [mediaUpdateProgram]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    updateRecipientProgram(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .updateRecipientProgram(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/notifications/recipients/{recipient_id}/copy`
     * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {NotificationRecipientCopyRequest} [notificationRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    v1CopyDataToNewRecipient(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .v1CopyDataToNewRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/copy`
     * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    v1CopyDataToNewRecipient_1(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .v1CopyDataToNewRecipient_1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/media/recipients/{recipient_id}/recommendations/guides`
     * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    v1MediaGuideRecommendations(params, options) {
        return (0, exports.MediaApiFp)(this.configuration)
            .v1MediaGuideRecommendations(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.MediaApi = MediaApi;
//# sourceMappingURL=media-api.js.map